import React, { Fragment, memo } from "react";
import { FixedSizeList as List, areEqual } from "react-window";
import Site from "./Site";

function composeFilteredSites(sites, matches, shouldFilter) {
  if (!shouldFilter) {
    return {
      included: sites,
    };
  }

  const included = sites.filter((site) => matches.has(site.syncoId));

  return {
    included,
  };
}

const Row = memo(({ index, data, style }) => {
  const { included, onClick, selectedSites } = data;
  const site = included[index];

  return (
    <div style={style}>
      <Site
        handleClick={onClick(site)}
        disabled={false}
        isSelected={selectedSites.has(site.syncoId)}
        label={site.label}
        key={site.syncoId}
      />
    </div>
  );
}, areEqual);

const Sites = ({
  sites,
  matches,
  selectedSites,
  onClick,
  shouldFilter = false,
}) => {
  const { included } = composeFilteredSites(sites, matches, shouldFilter);

  return (
    <Fragment>
      <List
        height={295}
        width="100%"
        itemCount={included.length}
        itemData={{
          included,
          selectedSites,
          onClick,
        }}
        itemSize={32}
      >
        {Row}
      </List>
    </Fragment>
  );
};

export default Sites;
